import { DateInput, type DateInputProps } from "@mantine/dates";
import { parseDayFirst } from "../helpers/common";
import { fromMantineDate } from "../helpers/mantineDates";

type NavDateInputProps = Omit<DateInputProps, "value" | "onChange"> & {
    value?: Date | null;
    onChange: (value: Date | null) => void;
    navUpdateDayOfWeek?: number | null;
};

const NavDateInput = ({
    value,
    onChange,
    navUpdateDayOfWeek,
    getDayProps,
    firstDayOfWeek = 0,
    locale = "en-gb",
    dateParser = parseDayFirst,
    valueFormat = "DD/MM/YYYY",
    ...props
}: NavDateInputProps) => {
    const isInvalidNavDay = (date: Date | null) =>
        Boolean(date && typeof navUpdateDayOfWeek === "number" && date.getDay() !== navUpdateDayOfWeek);

    const resolveDayProps: DateInputProps["getDayProps"] = (date) => {
        const existingDayProps = getDayProps?.(date) ?? {};
        const parsedDate = fromMantineDate(date);

        return {
            ...existingDayProps,
            disabled: Boolean(existingDayProps.disabled) || isInvalidNavDay(parsedDate),
        };
    };

    return (
        <DateInput
            firstDayOfWeek={firstDayOfWeek}
            locale={locale}
            dateParser={dateParser}
            valueFormat={valueFormat}
            value={value}
            onChange={(nextValue) => {
                const parsedDate = fromMantineDate(nextValue);
                if (isInvalidNavDay(parsedDate)) {
                    return;
                }
                onChange(parsedDate);
            }}
            getDayProps={resolveDayProps}
            {...props}
        />
    );
};

export default NavDateInput;
